<template>
	<!-- SUBMIT BUTTON & ANCHOR BUTTON -->
	<div v-if="url && url.includes('#')" :button="buttonClasses" :class="['cta-button']">
		<ButtonInnerContent :data="data" :showLoader="showLoader">
			<button v-if="props.type === 'submit'" type="submit"></button>
		</ButtonInnerContent>
	</div>

	<!-- RICHTEXT BUTTON | SHOULD HAVE UNDERLINE STYLE IN CONTENTFUL -->
	<a :href="data?.data?.uri" v-else-if="data.nodeType === 'hyperlink' && data?.content[0]?.marks.length" :button="buttonClasses" :class="['cta-button']">
		<ButtonInnerContent :data="data" :showLoader="showLoader" />
	</a>
	<!-- DEFAULT BUTTON -->
	<NuxtLink
		v-else
		prefetch
		:target="data?.target[0]"
		:button="buttonClasses"
		:class="['cta-button']"
		:data-wistia-id="wistiaID"
		v-if="data?.page?.fields?.slug || url"
		v-on:click="preventDefault"
		:to="data?.page?.fields?.slug ? localePath(`/${data?.page?.fields?.slug.replace('/', '')}`) : removeWistiaUrl(url)"
	>
		<ButtonInnerContent :data="data" :showLoader="showLoader" />
	</NuxtLink>
</template>
<script setup>
	import { useWistiaId } from '~~/composables/useWistiaId';
	import { useWistiaMediaId } from '~~/composables/useWistiaMediaId';

	const localePath = useLocalePath();
	const { $eventBus } = useNuxtApp();
	const props = defineProps({
		data: {
			type: Object,
			required: true
		},
		type: {
			type: String,
		}
	});

	const url = ref(props?.data?.url);
	const wistiaID = useWistiaId(url);
	const wistiaMediaId = useWistiaMediaId();
	const showLoader = ref(false);
	const buttonClasses = computed(() => [
		props?.data?.style,
		props?.data?.size,
		props?.data?.glowEffect === 'Enable' ? `glow-effect` : ''
	].join(' '));

	const removeWistiaUrl = (url) => {
		const wistiaUrl = 'immersivemoto.wistia.com';

		if(url.includes(wistiaUrl)) {
			return url.split(wistiaUrl).join('');
		}

		return url;
	};

	const preventDefault = (event) => {
		if(process.client) {
			if(url.value && url.value.includes('#') || url.value.includes('wistia.com')) {
				event.preventDefault();
			}
		}

		if(wistiaID.value) {
			wistiaMediaId.value = wistiaID.value;

			if(!document.getElementById(`wistia-jsonp-${wistiaMediaId.value}`)) {
				loadWistiaJSONP();
			}
		}
	}
	const loadWistiaJSONP = () => {
		return new Promise((resolve) => {
			const scriptId = `wistia-jsonp-${wistiaMediaId.value}`

			// ✅ Déjà chargé
			if (document.getElementById(scriptId)) {
				resolve();
				return;
			}

			const script = document.createElement('script')
			script.id = scriptId
			script.src = `https://fast.wistia.com/embed/medias/${wistiaMediaId.value}.jsonp`
			script.async = true
			script.onload = resolve

			document.head.appendChild(script)
		});
	};

	$eventBus.on('loader:show', (data) => {
		showLoader.value = data;
	});

	// console.log(wistiaID)
	// console.log(url.value)
</script>

<style lang="scss">
@use '~/assets/scss/components/Button.scss';
</style>
